export enum ColorVariants {
  MOST_IMPORTANT = 'most-important',
  IMPORTANT = 'important',
  DEFAULT = 'default',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DESTRUCTIVE = 'destructive',
  CATASTROPHIC = 'catastrophic',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  IMPORTANT_ALTERNATIVE = 'important-alternative',
  ALTERNATIVE = 'alternative',
  DISABLED = 'disabled',
  PREMIUM = 'premium',
  EXTRA = 'extra',
}
